import React from "react";
import { inject, observer } from "mobx-react";

const CampaignInfo = (props) => {
  const { teamprogress } = props.overlayStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const thermColor = urlParams.get('thermColor');

  return (
    <div className="container">
      <div className="therm-container">
        <div
          className={`therm-inner ${thermColor}`}
          style={{
            width: `${teamprogress}%`
          }}
        ></div>
      </div>
    </div>
  );
}

export default inject("overlayStore")(observer(CampaignInfo));
